import { Component, OnInit } from "@angular/core";
import { PoModule, PoNotificationService, PoTableAction } from "@po-ui/ng-components";
import { Router } from "@angular/router";
import { ProspectListService } from "./prospect-list.service";
import { PoPageFilter } from "@po-ui/ng-components";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-prospect-list",
  templateUrl: "./prospect-list.component.html",
  styleUrls: ["./prospect-list.component.css"],
  standalone: false,
})
export class ProspectListComponent implements OnInit {
  private filterModel: String;
  prospectList: Array<any> = new Array();
  actions: Array<PoTableAction> = [
    {
      action: this.viewProspect.bind(this),
      icon: "po-icon po-icon-eye",
      label: "Visualizar"
    }
    //   { action: this.deleteCustomer.bind(this), icon: 'po-icon-delete', label: 'Excluir' }
  ];
  columns: Array<any>;

  public loading: boolean = true;

  public readonly filter: PoPageFilter = {
    action: this.showAction.bind(this, "Filter"),
    placeholder: "Nome do cliente",
  };

  constructor(
    private prospectListService: ProspectListService,
    private router: Router,
    private poNotification: PoNotificationService
  ) {}

  ngOnInit() {
    this.updateProspectList("");
    this.columns = this.prospectListService.getColumns();
    this.loading = false;
  }

  updateProspectList(filtro: String): void {
    this.prospectListService.getProspectsList(filtro).subscribe(response => {
      this.prospectList = response;
    });
  }

  viewProspect(prospect: any) {
    this.router.navigate([`prospect-view/${prospect.id}`], {});
  }

  onClick() {
    this.router.navigate(["prospect-form"], {});
  }

  showAction(label) {
    this.updateProspectList(this.filterModel);
    //this.poNotification.success(`Action clicked: ${label + this.filterModel}`);
  }
}
